import { render, staticRenderFns } from "./OrgCapacityIcon.vue?vue&type=template&id=16876cff"
import script from "./OrgCapacityIcon.vue?vue&type=script&lang=js"
export * from "./OrgCapacityIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports